const formFieldTypeBase = (type) => ({
  name: '',
  type,
  label: '',
});

const formFieldTypeValidation = {
  required: false,
  minimum: null,
  maximum: null,
};

const formFieldTypeBaseWithValidation = (type) => ({
  ...formFieldTypeBase(type),
  validation: formFieldTypeValidation,
});

const formFieldTypeDefault = (type) => ({
  ...formFieldTypeBaseWithValidation(type),
  defaultValue: null,
});

const formFieldTypeDefaultPlaceholder = (type) => ({
  ...formFieldTypeDefault(type),
  placeholder: null,
});

export const formFieldFormats = {
  EMAIL: 'email',
  URI: 'uri',
  UUID: 'uuid',
};

export const formFieldArrayFormats = {
  EMAIL: 'emails',
  URI: 'uris',
  UUID: 'uuids',
};

const formFieldTypeBoolean = {
  ...formFieldTypeBase('boolean'),
  defaultValue: null,
  validation: {
    required: false,
  },
};

const formFieldTypeString = (format = null) => ({
  ...formFieldTypeDefaultPlaceholder('string'),
  validation: { format },
});

const formFieldTypeStrings = {
  ...formFieldTypeBaseWithValidation('strings'),
  placeholder: null,
  options: [],
};

const formFieldTypeLink = {
  ...formFieldTypeBase('link'),
  text: formFieldTypeDefaultPlaceholder('string'),
  link: formFieldTypeString(formFieldFormats.URI),
  target: formFieldTypeDefaultPlaceholder('string'),
  validation: {
    required: false,
  },
};

const formFieldTypeLinks = {
  ...formFieldTypeBaseWithValidation('links'),
  placeholder: null,
  text: formFieldTypeDefaultPlaceholder('string'),
  link: formFieldTypeString(formFieldFormats.URI),
  target: formFieldTypeDefaultPlaceholder('string'),
};

const formFieldTypeObject = {
  ...formFieldTypeBase('object'),
  fields: [],
  validation: {
    required: false,
  },
};

const formFieldTypeObjects = {
  ...formFieldTypeBaseWithValidation('objects'),
  placeholder: null,
  fields: [],
  summary: [],
};

const formFieldTypeList = {
  ...formFieldTypeDefaultPlaceholder('list'),
  validation: { ...formFieldTypeValidation, multiple: false },
  options: [],
};

const formFieldTypePhone = {
  ...formFieldTypeDefaultPlaceholder('phone'),
  preferredCountries: [],
  country: null,
};

const formFieldTypeAuth = {
  ...formFieldTypeDefaultPlaceholder('auth'),
  authProvider: null,
  authority: null,
  clientId: null,
  scopes: [],
  tokenScopes: [],
  authorityDomain: null,
  domainHint: null,
};

const formFieldSimpleEditableTypes = {
  AUTH: formFieldTypeAuth,
  BOOL: formFieldTypeBoolean,
  DATE: formFieldTypeDefaultPlaceholder('date'),
  LIST: formFieldTypeList,
  MD: formFieldTypeDefault('markdown'),
  MDS: formFieldTypeDefault('markdowns'),
  NUMBER: formFieldTypeDefaultPlaceholder('number'),
  PHONE: formFieldTypePhone,
  STRING: formFieldTypeString(),
  STRINGS: formFieldTypeStrings,
  TEXT: formFieldTypeDefault('text'),
  TEXTS: formFieldTypeDefault('texts'),
};

const formFieldEditableTypes = {
  ...formFieldSimpleEditableTypes,
  LINK: formFieldTypeLink,
  LINKS: formFieldTypeLinks,
  OBJECT: formFieldTypeObject,
  OBJECTS: formFieldTypeObjects,
};

const formFieldNonEditableTypes = {
  LABEL: formFieldTypeBase('label'),
};

const formFieldTypes = {
  ...formFieldEditableTypes,
  ...formFieldNonEditableTypes,
};

export const formFieldSimpleArrays = [
  formFieldTypes.MDS,
  formFieldTypes.STRINGS,
  formFieldTypes.TEXTS,
];

export const formObjectArrays = [
  formFieldTypes.OBJECTS,
  formFieldTypes.LINKS,
];

export const formFieldArrays = [
  ...formFieldSimpleArrays,
  ...formObjectArrays,
];

export const includesFieldType = (types, value) => types.map(({ type }) => type).includes(value);

export const editableFormFieldTypes = Object.values(formFieldEditableTypes).map(({ type }) => type);

export const fieldTypeFormats = {
  [formFieldFormats.URI]: {
    [formFieldTypes.STRING.type]: { format: formFieldFormats.URI },
    [formFieldTypes.STRINGS.type]: { format: formFieldArrayFormats.URI },
  },
  [formFieldFormats.UUID]: {
    [formFieldTypes.STRING.type]: { format: formFieldFormats.UUID },
    [formFieldTypes.STRINGS.type]: { format: formFieldArrayFormats.UUID },
  },
  [formFieldFormats.EMAIL]: {
    [formFieldTypes.STRING.type]: { format: formFieldFormats.EMAIL },
    [formFieldTypes.STRINGS.type]: { format: formFieldArrayFormats.EMAIL },
  },
};

export default formFieldTypes;
